module.exports = __webpack_public_path__ + "apple-icon-57x57.d45a9bee.png";